import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';

import packageJson from '../package.json';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import {
  ErrorHint,
  combinedMessageRegex,
  ignoredErrors,
} from './sentryIgnoredErrors';

const shouldIgnoreError = (error?: ErrorHint['originalException']): boolean => {
  if (!error) return false;

  for (const rule of ignoredErrors) {
    if (
      (rule?.status !== undefined && error?.status === rule?.status) ||
      (rule?.message && error?.message?.includes(rule?.message))
    ) {
      return true;
    }
  }
  return error?.message ? combinedMessageRegex?.test(error?.message) : false;
};

Sentry.init({
  dsn: environment.sentryDsn,
  release: packageJson.version,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.2,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  beforeSend(event: any, hint: any) {
    return shouldIgnoreError(hint?.originalException) ? null : event;
  },
  enabled: environment.production,
});

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
